export default {
  SelectedItem: {
    mounted() {
      this.initialize();
    },

    updated() {
      this.initialize();
    },

    initialize() {
      this.register_selection_handler();
    },

    register_selection_handler() {
      this.handleEvent('itemSelected', ({ id, old_id }) => {
        // Selection is expressed as a `data-selected` attribute so the styling
        // lives in the templates (Tailwind data variants), not in here.
        const oldElement = old_id && document.getElementById(old_id);
        if (oldElement) {
          oldElement.removeAttribute('data-selected');
        }

        const newElement = id && document.getElementById(id);
        if (newElement) {
          newElement.setAttribute('data-selected', '');
        }
      });
    },
  },
};
